import { CheckoutTrafficScreen } from '@features/admin/ui/CheckoutTrafficScreen'
import { PermissionGate } from '@shared/ui/PermissionGate'
export function OrigensCheckoutPage() {
  return (
    <PermissionGate permission="PRODUCT_READ">
      <CheckoutTrafficScreen />
    </PermissionGate>
  )
}
